import {Component, HostBinding, Input} from '@angular/core';
import { LocalSettingsService } from 'shared/local-settings/local-settings.service';

@Component({
  selector: 'instruction',
  templateUrl: 'instruction.html',
  styleUrls: ['instruction.scss'],
})
export class InstructionComponent {

  public static INS_PREFIX: string = 'INSTR_';

  @HostBinding('class') public klass: string = 'hide';

  constructor(
    private localSettingsService: LocalSettingsService,
  ) { }


  @Input() public set key(key: string) {
    // console.log("instruction "+ key);
    this.localSettingsService.doWaiting(() => {
      this.localSettingsService.get(LocalSettingsService.MODE)
        .then((mode) => {
          if (mode != 'simple') {
            this.localSettingsService.get(InstructionComponent.INS_PREFIX + key)
              .then((result) => {
                // console.log("instruction "+ key + ":  "+ result);
                if ( result === null ) {
                  this.klass = 'displayed';
                  this.localSettingsService.set(InstructionComponent.INS_PREFIX + key, "1");
                  setTimeout(() => this.hide(), 8000);
                }
            });
          }
        });
      });
  }

  public hide() {
    if (this.klass == 'displayed') {
      this.klass = 'displayed closing';
      setTimeout(() => { this.klass = 'hide'; }, 1000);
    }
  }
}
